export const INPUT_TYPE_RADIO = "radio";
export const INPUT_TYPE_CHECKBOX = "checkbox";
export const INPUT_TYPE_SELECT = "select";
export const INPUT_TYPE_NUMBER = "number";
export const INPUT_TYPE_TEXT = "text";
export const INPUT_TYPE_TEXT_ALIGNMENT = "textAlignment";
export const INPUT_TYPE_PASSWORD = "password";
export const INPUT_TYPE_TEXT_AREA = "textarea";
export const INPUT_TYPE_COLOR = "color";
export const INPUT_TYPE_THEME_COLORS = "themecolors";
export const INPUT_TYPE_FILE = "file";
export const INPUT_TYPE_IMAGE = "image";

export const ELEMENT_SIMPLE_PROPS = [
  {
    name: "bgcolor",
    label: "Background Color",
  },
  {
    name: "fillType",
    label: "Fill Type",
  },
  {
    name: "bW",
    label: "Border Width",
  },
  {
    name: "bC",
    label: "Border Color",
  },
];

export default {
  INPUT_TYPE_RADIO,
  INPUT_TYPE_CHECKBOX,
  INPUT_TYPE_SELECT,
  INPUT_TYPE_NUMBER,
  INPUT_TYPE_TEXT,
  INPUT_TYPE_PASSWORD,
  INPUT_TYPE_TEXT_AREA,
  INPUT_TYPE_COLOR,
  INPUT_TYPE_THEME_COLORS,
  INPUT_TYPE_FILE,
  INPUT_TYPE_IMAGE,
};
